import axios from 'axios';

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api/v1';

const getAuthHeaders = token => ({
  headers: { Authorization: `Bearer ${token}` },
});

const sanitizeParams = params =>
  Object.fromEntries(
    Object.entries(params || {}).filter(
      ([, value]) => value !== undefined && value !== null && value !== ''
    )
  );

export const getPresentationConfig = async token => {
  const response = await axios.get(
    `${API_BASE_URL}/generate/franca/presentation/config`,
    getAuthHeaders(token)
  );
  return response.data;
};

export const generatePresentation = async (token, payload) => {
  const response = await axios.post(
    `${API_BASE_URL}/generate/franca/presentation`,
    payload,
    getAuthHeaders(token)
  );
  return response.data;
};

export const getPresentationStatus = async (token, generationId) => {
  const response = await axios.get(
    `${API_BASE_URL}/generate/franca/presentation/status/${generationId}`,
    getAuthHeaders(token)
  );
  return response.data;
};

export const listPresentationThemes = async (token, params = {}) => {
  const response = await axios.get(
    `${API_BASE_URL}/generate/franca/presentation/themes`,
    {
      ...getAuthHeaders(token),
      params: sanitizeParams(params),
    }
  );
  return response.data;
};

export const listPresentationFolders = async (token, params = {}) => {
  const response = await axios.get(
    `${API_BASE_URL}/generate/franca/presentation/folders`,
    {
      ...getAuthHeaders(token),
      params: sanitizeParams(params),
    }
  );
  return response.data;
};

